import { render, staticRenderFns } from "./RemovedUsersList.vue?vue&type=template&id=db5b6254&scoped=true&"
import script from "./RemovedUsersList.vue?vue&type=script&lang=js&"
export * from "./RemovedUsersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5b6254",
  null
  
)

export default component.exports